import { getDirectusClient } from "../lib/directus";
import { readItems, updateItem } from "@directus/sdk";
const directus = getDirectusClient();

export const getGrupos = async () => {
  const response = await directus.request(
    readItems("grupos", {
      fields: "*",
      sort: "-date_created",
      limit: -1,
    })
  );    
  return response;
};
export const updategrupo = async (id, data) => {
  try {
    const response = await directus.request(updateItem("grupos", id, data));
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const getGruposCount = async () => {
  const response = await directus.request(
    readItems("grupos", {
      fields: "*",
      sort: "-date_created",
      limit: -1,
      aggregate: {
        countDistinct: ["id"],
      },
    })
  );
  return response;
};
export const getGruposCountByNombre = async (nombre) => {
    const response = await directus.request(
      readItems("grupos", {
        fields: "*",
        sort: "-date_created",
        limit: -1,
        aggregate: {
          countDistinct: ["id"],
        },
        filter: {
          nombre: {
            _contains: nombre,
          },
        },
      })
    );
    return response;
  };

export const getGruposByNombre = async (nombre, page = 1, limit = -1) => {
  try {
    const response = await directus.request(
      readItems("grupos", {
        fields: "*",
        sort: "-date_created",
        filter: {
          _and: [
            {
              nombre: {
                _contains: nombre,
              },
            },
          ],
        },
        page: page,
        limit: limit,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getGruposSinCodebar = async (page = 1, limit = -1) => {
  try {
    const response = await directus.request(
      readItems("grupos", {
        fields: "*",
        sort: "-date_created",
        filter: {
          _and: [
            {
              codebar: {
                _eq: false
              }
            }
          ]
        },
        page: page,
        limit: limit,
      })
    );
    return response;
  } catch (error) {
    throw error;
  }
};

